export default "__VITE_ASSET__CTxntJ6j__"